module.exports = __webpack_public_path__ + "img/151.3f0ba91b.jpg";